<template>
  <div>
    <input hidden />
    <v-select
      required
      item-text="descricao"
      item-value="id"
      label="Motivo da 2ª Via"
      v-model="motivoSegundaViaId"
      :items="dmMotivosSegundaVia"
    ></v-select>
    <v-textarea
      label="Justificativa"
      name="justificativa"
      v-if="motivoSegundaViaIsOutros"
      v-model="justificativa"
    ></v-textarea>
    <v-layout row justify-end>
      <v-btn flat @click="cancelar()">Cancelar</v-btn>
      <v-btn
        color="primary"
        @click="criarRascunho()"
        :disabled="!motivoSegundaViaId || loading"
      >
        Próximo
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { listarMotivosSegundaVia } from "@/services/movimentos";

const MOTIVO_SEGUNDA_VIA_OUTROS = "00000000-0000-0000-0000-000000000003";

export default {
  name: "EtapaMotivoSegundaVia",
  props: {
    loading: Boolean,
    movimentoId: Number
  },
  watch: {
    movimentoId: {
      handler() {
        this.limparDadosMovimento();
      }
    },
    motivoSegundaViaId: {
      handler() {
        this.motivoSegundaViaIsOutros =
          this.motivoSegundaViaId === MOTIVO_SEGUNDA_VIA_OUTROS;
      }
    }
  },
  data() {
    return {
      dmMotivosSegundaVia: null,
      justificativa: null,
      motivoSegundaViaId: null,
      motivoSegundaViaIsOutros: false
    };
  },
  created() {
    this.motivosSegundaVia();
  },
  methods: {
    cancelar() {
      this.limparDadosMovimento();
      this.$emit("cancelar");
    },
    criarRascunho() {
      this.$emit("criar-rascunho", {
        justificativa: this.justificativa,
        motivoSegundaViaId: this.motivoSegundaViaId
      });
    },
    limparDadosMovimento() {
      this.justificativa = null;
      this.motivoSegundaViaId = null;
    },
    async motivosSegundaVia() {
      await listarMotivosSegundaVia().then(response => {
        this.dmMotivosSegundaVia = response;
      });
    }
  }
};
</script>
